import { FC } from 'react';

import { Avatar, Tag, Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { BrowsedJobDetailsContainerStyled } from '../TechnicianBrowsedJobDetails/style';

interface UserProfilePropsType {
  name?: string;
  email?: string;
  position?: string;
  imgUrl?: string;
}

const UserProfile: FC<UserProfilePropsType> = ({
  name,
  email,
  position,
  imgUrl,
}) => {
  const getTagColors = (label: string) => {
    if (label === 'FIREMAN') {
      return 'danger';
    }
    return 'caution';
  };
  return (
    <BrowsedJobDetailsContainerStyled>
      <Typography
        variant="normal"
        fontColor="secondary"
        className="userProfile"
        strong
      >
        USER PROFILE{' '}
      </Typography>
      <VerticalSpaceStyled>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
            marginTop: '20px',
          }}
        >
          <InfoRowStyled className="userImage">
            <Avatar size="xl" src={imgUrl || ''} />
          </InfoRowStyled>
          <InfoRowStyled>
            <Typography fontColor="dark">{name || 'Nitish Rajak'} </Typography>
          </InfoRowStyled>
          <InfoRowStyled>
            <Typography fontColor="disable">
              {email || 'nitish.technician@gmail.com'}
            </Typography>
          </InfoRowStyled>
          <InfoRowStyled>
            <Tag type={getTagColors(position || 'Hotel Manager')}>
              {position || 'Hotel Manager'}
            </Tag>
          </InfoRowStyled>
        </div>
      </VerticalSpaceStyled>
    </BrowsedJobDetailsContainerStyled>
  );
};

export default UserProfile;
